export const isLineChartPathDefined = (d: any, key = 'value'): any =>
  d[key] && d.attribute !== 'ud';
